import React from "react";

const ErrorMessage = ({ touched, error }) => {
  return touched && error ? <div className="form-error">{error}</div> : null;
};

export default ErrorMessage;
